import { Component, OnInit, ElementRef } from '@angular/core';
import { IMultiSelectOption } from 'angular-2-dropdown-multiselect';
import { DesignAttributeType } from '../../../../types/designer-attribute-type';
import { BaseDesignerComponent } from "../../base/base-designer-component";

@Component({
    selector: 'sx-marca-designer',
    templateUrl: './marca.designer.component.html'
})
export class SxMarcaDesigner extends BaseDesignerComponent implements OnInit {
    optionsModel: string[];
    options: IMultiSelectOption[];

    constructor(container: ElementRef) {
        super(container, "SxMarca");
    }
    
    getDesignerInfo(): any {
        let info = super.getDesignerInfo();

        info["options"] = [];
        info["options"].push({ id: '1', name: 'chevrolet' });
        info["options"].push({ id: '2', name: 'ford' });
        info["options"].push({ id: '3', name: 'audi' });

        return info;
    }

    ngOnInit(): void {
        this.options = [];
        this.options.push({ id: '1', name: 'Capital Federal' });
        this.options.push({ id: '1', name: 'Buenos Aires' });
        this.options.push({ id: '1', name: 'Cordoba' });

    }

    onChange() {
        
    }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/deprecated/marca.designer.component.ts